var setup = {
  chapters_enabled: [
    "1-Tabla univariada", 
    "2-Tabla bivariada",
    "3-Media y desvío",
    "4-Muestreo",
    "5-Intervalo de confianza",
    "6-Prueba t",
    "7-Chi cuadrado de independencia",
    "8-Correlación",
  ]
}

export default setup
